import { lazy, Suspense } from "react";
import Loader from '../custom/loader/main';

const Main = lazy(() => import('../components/uploadPage/main'));

const Uploads = () => {
    return (
        <Suspense fallback={<Loader/>}>
            <Main/>
        </Suspense>
    )
}

export default Uploads;